// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2uSloiMttKQkL-BX-vNXzL","title":"_23JVTNY9zSoy2pDurBIYN3","content":"ltI_3SetFqkHMR8HU4AbV","redirect_link":"_1t6tbhmJXTcvDCzvLFckhZ"};